{
  "title": "PM",
  "actions": {
    "new": "Opprett PM",
    "newAndClear": "Opprett og tøm",
    "reorderItem": "Dra for å flytte {{headline}}",
    "selectAll": "Velg alle",
    "deselectAll": "Fjern alle valg",
    "removeBlock": "Fjern blokk",
    "removeItem": "Fjern {{headline}}",
    "addBlock": "Legg til {{label}}",
    "insertDocument": "Sett inn {{title}}",
    "removeInsertedDocument": "Fjern innsatt {{title}}",
    "removeInsertedLine": "Fjern linjen {{text}}"
  },
  "labels": {
    "memo": "PM-et",
    "selection": "Utvalg",
    "planningTitle": "Tittel på planleggingen",
    "assignmentTitle": "Tittel på oppdraget",
    "memoTitle": "Tittel på PM-et",
    "planningSlugline": "Slugg på planleggingen",
    "assignmentSlugline": "Slugg på oppdraget",
    "dateFrom": "Fra dato",
    "dateTo": "Til dato",
    "candidates": "Å velge mellom",
    "print": "Printartikler",
    "planning": "Planlegginger",
    "article": "Artikler",
    "events": "Hendelser",
    "insertable": "Sett inn publisert PM",
    "chooseBlock": "Velg blokk",
    "insertSelectedInto": "Legg markerte i blokk",
    "unassignedCount": "{{count}} markerte",
    "preview": "Forhåndsvisning",
    "keywordFor": "Nøkkelord for {{headline}}",
    "noKeyword": "-"
  },
  "placeholders": {
    "template": "Velg mal",
    "section": "Velg seksjon",
    "memoSection": "Kategori for PM",
    "editorialInfoType": "Velg redaksjonell type",
    "newsvalue": "Nyhetsverdi",
    "filterSection": "Kategori",
    "filterStory": "Story",
    "variant": "Velg dager"
  },
  "errors": {
    "itemsRequired": "Velg poster for å opprette PM-et",
    "sectionMissing": "Seksjonen {{section}} ble ikke funnet",
    "sectionRequired": "Velg hvilken seksjon PM-et gjelder",
    "templateRequired": "Velg en mal for å søke etter innhold"
  },
  "hints": {
    "draftOnly": "PM-et opprettes som et utkast. Det publiseres aldri automatisk."
  },
  "banner": {
    "offline": "Du er offline. PM kan ikke opprettes før tilkoblingen er tilbake."
  },
  "toasts": {
    "created": "PM opprettet"
  },
  "prompts": {
    "createSeveral": "Du kommer til å opprette følgende PM"
  }
}
